import React from 'react';
import { styled } from '@compiled/react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { graphql, useFragment } from 'react-relay';
import { token } from '@atlaskit/tokens';
import type { providerLogo_softwareReleasesLaunchCard$key } from '@atlassian/jira-relay/src/__generated__/providerLogo_softwareReleasesLaunchCard.graphql';
import fallbackProviderLogoUrl from './assets/addon.svg';

type Props = {
	provider: providerLogo_softwareReleasesLaunchCard$key;
};

export const ProviderLogo = ({ provider }: Props): React.JSX.Element => {
	const { name, logoUrl } = useFragment(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment providerLogo_softwareReleasesLaunchCard on DevOpsDeploymentProvider {
				name
				logoUrl
			}
		`,
		provider,
	);
	return (
		<CircularLogo
			src={logoUrl ?? ''}
			alt={name ?? ''}
			title={name ?? ''}
			onError={(e) => {
				if (e.target instanceof HTMLImageElement) {
					e.target.src = fallbackProviderLogoUrl;
				}
			}}
		/>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CircularLogo = styled.img({
	width: '32px',
	height: '32px',
	paddingTop: token('space.100'),
	paddingRight: token('space.100'),
	paddingBottom: token('space.100'),
	paddingLeft: token('space.100'),
	borderRadius: token('radius.full'),
	// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
	boxShadow: '0px 3px 5px rgba(9, 30, 66, 0.2), 0px 0px 1px rgba(9, 30, 66, 0.31)',
	// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
	backgroundColor: 'white',
});
